import { createContext } from 'react';

const BlockChainTTAPIContext = createContext({});

export default BlockChainTTAPIContext;
